import { store } from '@/store/index';

export const magicLinkState = () => {
  const state: any = store.getState();
  return state.magicLink;
};
